import type { AppError } from "./app-error";
import { useModalService } from "../../services/modal-service";
import { ErrorFactory } from "./error-factory"
import ErrorModal from "../../components/errorHandling/ErrorModal.vue"

import ModalContainer from "../../components/ModalContainer.vue";

let openErrors = 0;
let modalContainerRef: typeof ModalContainer | null = null;

export function setModalContainer(modalContainer: typeof ModalContainer) {
    modalContainerRef = modalContainer;
}

export function showUIError(error: AppError) {
    const modal = useModalService();
    openErrors++;
    modal.showModal(ErrorModal, {error: ErrorFactory.fromError(error)}, {showTitle:false, showCloseButton: false}).then(() => {
        openErrors--;
    });
}

export function isUIErrorOpen() {
    return openErrors > 0;
}

export function hideUIError() {
    if (openErrors > 0 && modalContainerRef != null) {
        modalContainerRef.closeCurrentModal();
        openErrors--;
    }
}
